<template>
  <div class="box11">
    <div class="subTitle">就业速度快 薪资涨幅高</div>
    <pageTitle title="在博学谷学习后<br/>他们已成功晋级架构师" text="" />

    <div class="content">
      <div class="border">
        <div class="content-top">
          <div class="name name1">姓名</div>
          <div class="education">学历</div>
          <div class="before">学前薪资</div>
          <div class="after">转型后月薪</div>
          <div class="unit">就业单位</div>
        </div>
      </div>
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in salaryList"
          :key="index"
        >
          <div class="item">
            <div class="name">{{ item.name }}</div>
            <div class="education">{{ item.education }}</div>
            <div class="before">{{ item.before }}</div>
            <div class="after">{{ item.after }}</div>
            <div class="unit">{{ item.unit }}</div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import pageTitle from "../common/pageTitle.vue";
import "swiper/dist/css/swiper.css";
export default {
  components: { pageTitle, swiper, swiperSlide },
  data() {
    return {
      swiperOption: {
        // swiper配置
        direction: "vertical", // 滑动方向改为垂直
        height: 72, //你的slide高度 强制性 垂直方向生效
        loop: true, //是否循环
        freeMode: true,
        speed: 3000,
        autoplay: {
          delay: 0, // 自动播放的时长
          stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
          disableOnInteraction: false,
        },
        grabCursor: true,
        slidesPerView: "auto",
      },
      salaryList: [
        {
          name: "朱**",
          education: "本科",
          before: "29000",
          after: "37500",
          unit: "**(上海)有限公司",
          up: "29.31",
        },
        {
          name: "解**",
          education: "本科",
          before: "22800",
          after: "35417",
          unit: "****通集团",
          up: "55.34",
        },
        {
          name: "陶**",
          education: "本科",
          before: "20000",
          after: "35333",
          unit: "**(上海)分公司",
          up: "76.67",
        },
        {
          name: "董**",
          education: "本科",
          before: "19000",
          after: "33183",
          unit: "上海**有限公司",
          up: "74.65",
        },
        {
          name: "李**",
          education: "本科",
          before: "17000",
          after: "28750",
          unit: "江**信有限公司",
          up: "69.12",
        },
        {
          name: "张**",
          education: "本科",
          before: "20000",
          after: "27083",
          unit: "北京**通有限公司",
          up: "35.42",
        },
        {
          name: "柳**",
          education: "硕士",
          before: "15300",
          after: "26833",
          unit: "深圳**有限公司",
          up: "75.38",
        },
        {
          name: "姜**",
          education: "本科",
          before: "20000",
          after: "26667",
          unit: "上海**有限公司",
          up: "33.34",
        },
        {
          name: "丁**",
          education: "本科",
          before: "16000",
          after: "26000",
          unit: "杭州**有限公司",
          up: "62.50",
        },
        {
          name: "马**",
          education: "本科",
          before: "16000",
          after: "25000",
          unit: "****上海公司",
          up: "56.25",
        },
        {
          name: "杨**",
          education: "本科",
          before: "15500",
          after: "22500",
          unit: "**信息有限公司",
          up: "45.16",
        },
        {
          name: "陈**",
          education: "本科",
          before: "17000",
          after: "22000",
          unit: "上海**有限公司",
          up: "29.41",
        },
        {
          name: "刘**",
          education: "本科",
          before: "14000",
          after: "22000",
          unit: "深圳市**有限公司",
          up: "57.14",
        },
        {
          name: "袁**",
          education: "本科",
          before: "18000",
          after: "22000",
          unit: "上海**有限公司",
          up: "22.22",
        },
        {
          name: "张**",
          education: "专科",
          before: "13000",
          after: "21677",
          unit: "****杭州公司",
          up: "66.75",
        },
        {
          name: "崔**",
          education: "本科",
          before: "18000",
          after: "21500",
          unit: "杭州****院",
          up: "19.44",
        },
        {
          name: "崔**",
          education: "本科",
          before: "16000",
          after: "21000",
          unit: "北京**科技公司",
          up: "31.25",
        },
        {
          name: "徐**",
          education: "专科",
          before: "16500",
          after: "21000",
          unit: "北京**软件公司",
          up: "27.27",
        },
        {
          name: "郭**",
          education: "本科",
          before: "17000",
          after: "21000",
          unit: "上海**科技公司",
          up: "23.53",
        },
        {
          name: "彭**",
          education: "本科",
          before: "15000",
          after: "20583",
          unit: "广州**传播公司",
          up: "37.22",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.box11 {
  padding-top: 80px;
  padding-bottom: 64px;
  width: 100%;
  background: #f5f9ff;

  /deep/ .swiper-container-free-mode > .swiper-wrapper {
    -webkit-transition-timing-function: linear; /*之前是ease-out*/
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
    margin: 0 auto;
  }

  .subTitle{
    font-family: PingFangSC-Semibold;
	font-size: 32px;
	font-weight: normal;
	font-stretch: normal;
	
	letter-spacing: 0px;
	color: #24375c;
  text-align: center;
  margin-bottom: 29px;
  }

  .title {
    margin-bottom: 48px;
    font-family: PingFangSC-Semibold;
    font-size: 40px;
    font-weight: bold;
    line-height: 62px;
    text-align: center;
    color: #24375c;
    p {
      color: #0350a0;
    }
  }

  .content {
    margin: 0 auto;
    width: 686px;
    height: 96px;
    height: 864px;
    background: #ffffff;
    box-shadow: 0px 8px 24px 0px rgba(64, 128, 255, 0.12);
    border-radius: 24px;
    overflow: hidden;
    margin-top: 48px;

    -webkit-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);

    .border {
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 1),
        rgba(255, 255, 255, 0)
      );

      padding: 2px;
      border-radius: 24px 24px 0 0;
      overflow: hidden;
      margin: -2px;
    }
    .swiperitems1 {
      border-radius: 0 0 24px 24px;
    }
    .swiperwrap {
      background-color: #ffffff !important;
      position: relative;
      z-index: 20;
    }
    .item {
      display: flex;

      text-align: center;
      height: 96px;
      background: #ffffff;
      line-height: 96px;
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #4e5969;
      box-sizing: border-box;
      border-bottom: 2px solid rgba(232, 243, 255, 0.8);
    }
    .name {
      width: 120px;
      height: 96px;
    }
    .name1 {
      border-radius: 24px 0 0 0;
    }
    .education {
      width: 80px;
      height: 96px;
    }
    .before {
      width: 128px;
      height: 96px;
    }
    .after {
      width: 128px;
      height: 96px;

      color: #165dff;
    }
    .unit {
      width: 230px;
      height: 96px;
    }

    .content-top {
      display: flex;
      height: 96px;
      box-sizing: border-box;
      // background: linear-gradient(180deg, #d7e3ff 0%, #f3f7ff 100%);
      background: url("../../../assets/coursePage/java/box9/topbgc.png")
        no-repeat;
      background-size: cover;
      width: 100%;
      div {
        // flex: 1;
        text-align: center;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1d2129;
        line-height: 96px;
      }
    }
  }
}
</style>
